export function isEqual(a: any[], b: any[]) {
    let is = true;
    a.forEach((i: any) => {
        if (!~b.indexOf(i)) {
            is = false;
            return;
        }
    });
    return is;
}
